
export enum RouteAutoSequenceTypeCd {
	DOMICILE = 'Domicile',
	GO_FAR = 'GoFar',
	PICKUP_POINT = 'PickupPoint',
	PINNED = 'Pinned'}
